import React from "react";
import { TitledContent } from "./TitledContent";
import { useLoaderData } from "react-router-dom";
import client from "../descriptors/client";
import { ListResult } from "../utils/crud";
import List from "./List";
import { FormattedMessage } from "react-intl";

const ClientsPage: React.FC = () => {
    const data = useLoaderData() as ListResult;
    const descriptor = client;
    const resourceName = "client";

    return (
        <TitledContent title={<FormattedMessage id="client.list" />}>
            <List
                data={data.rows}
                maxPage={Math.ceil(data.count / descriptor.listDefaults.limit)}
                header={descriptor.orders.list}
                uri={new URL(window.location.href)}
                renderers={descriptor.renderers?.list}
                fieldNameKeyFactory={(fieldName: string) => `${resourceName}.${fieldName}`}
            />
        </TitledContent>
    );
};

export default ClientsPage;
